<template>
  <div class="contenido">
    <v-card v-for="(card, index) in cards" :key="card.name" :class="classObject(index)" flat>
      <div class="contenidocaja" @click="clickHandler(card.path)">
        <v-layout>
          <v-flex xs2 lg2>
            <v-icon size="60" :class="classObject(index)">{{ card.icon }}</v-icon>
          </v-flex>
          <v-flex xs10 lg10>
            <v-card-title primary-title>
              <div>
                <div class="headline">{{ card.name }}</div>
                <div>{{ card.detail }}</div>
              </div>
            </v-card-title>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'CardList',
  props: {
    cards: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    classObject(e) {
      // En base a la posición se marca un estilo distinto box1, box2, box3
      var contador = e % 3;
      return 'box' + contador;
    },
    clickHandler(path) {
      // Redireccionamos
      this.$router.push(path);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import 'src/resources/styles/variables.scss';

@supports (display: grid) {
  .contenido {
    display: grid;
    grid-gap: 40px;
    padding-top: 20px;
    grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
    cursor: pointer;
    .v-card {
      max-width: inherit !important;
      margin: inherit !important;
    }
  }
}

/* IE11 */
.contenido .v-card {
  font-size: 1rem;
  max-width: 500px;
  margin: 20px;
  float: left;
  border: none;
  .contenidocaja {
    padding: 30px 0px;
    text-align: left;
    i {
      margin: 15px 0px 0px 30px;
    }
  }
}

.box0 {
  background-color: $color-tertiary !important;
  color: $color-black !important;
}

.box1 {
  background-color: $color-secondary !important;
  color: $color-text-regular !important;
}

.box2 {
  background-color: $color-primary !important;
  color: #fff !important;
}
</style>
